module.exports = __webpack_public_path__ + "media/hal_notification.14a6460c.mp3";